module.exports = __webpack_public_path__ + "media/images/custom_page/ab6ix_event2/ab6ix-event-en-31610388dc5a2190a0e1e80f31b2eb14.png";